<div class="related-story-listing-class">
  
    <div class="headingPage">
      <h2 class="">Select Breaking News</h2>
    </div>
    <div class="listing-class">
      <div class="searchBlock">
        <div class="searchSection"><i class="icon-search"></i>
          <div class="searchtxt">
            <input type="text" class="textBox" placeholder="Search..." [formControl]='searchQuery'>
          </div>
        </div>
      </div>
      <div class="headingsList">
        <ul>
          <li class="headlineBreak">Headline </li>
          <li class="urlBreak">Url</li>
          <li class="rentOn">Sent On</li>
          <li class="pickUp">Pick Up</li>
        </ul>
      </div>
      <div class="contentList">
        <ng-container *ngFor="let item of listArray; let i = index">
          <ul>
            <li class="headlineBreak">
              <small [title]="item.headline">
                <div class="listCell">{{item.headline}}</div>
              </small>
            </li>
            <li class="urlBreak" [title]="item.url">
              <ng-container *ngIf="currentSelectedIndex !== i">
                <label>{{item.url}}</label>
                <i class="icon-options" (click)="selectEditItem(i,item.url)"></i>
              </ng-container>
              <ng-container *ngIf="currentSelectedIndex === i">
                <input type="text" class="textBox" [(ngModel)]="editingURL">
                <i class="icon-checkbox-tick" (click)="saveEditItem(i, item)"></i>
              </ng-container>
            </li>
            <li class="rentOn" [title]="item.lastUpdatedDate">{{getNewTypeDate(item.lastUpdatedDate)}}</li>
            <li *ngIf="!item.url" class="pickUp" title="pick"><i class="icon-pickup" (click)="pickItem(item)"></i></li>
          </ul>
        </ng-container>
      </div>
      <div class="padCenter20">
        <button (click)="callMoreData()" [disabled]="lastPage">Call More Items</button>
      </div>
    </div>
  
</div>